import { loginActionTypes } from './../constants/ApiConstants';

const initialState = {
  loaderBusinessToken: false,
  businessNameCheck: false,
  businessCheckMessage: null,
  access_token: null,
  authenticating: false,
  errorMessage: null,
  loginUserInfo: null,
  authenticatingToken: false,
  loginResponse: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case loginActionTypes.check_business_name.REQUEST:
    return {
      ...state,
      loaderBusinessToken: true,
      businessNameCheck: false,
      businessCheckMessage: null,
    };
  case loginActionTypes.check_business_name.SUCCESS:
    return {
      ...state,
      loaderBusinessToken: false,
      businessNameCheck: payload.access_token,
      businessCheckMessage: payload.businessCheckMessage,
      organizationDetails: payload.organizationDetails,
    };
  case loginActionTypes.post_login.REQUEST:
    return {
      ...state,
      authenticating: true,
      loginResponse: null,
      successMessage: null,
      errorMessage: null,
    };
  case loginActionTypes.post_login.SUCCESS:
    return {
      ...state,
      authenticating: false,
      errorMessage: payload.errorMessage,
      access_token: payload.access_token,
      loginUserInfo: payload.loginUserInfo,
      currentLocationId: payload.currentLocationId,
      loginResponse: payload.response,
    };
  case loginActionTypes.post_login.FAILURE:
    return {
      ...state,
      authenticating: false,
      authenticatingToken: false,
      errorMessage: payload.errorMessage,
      access_token: payload.access_token,
      loginUserInfo: payload.loginUserInfo,
      loginResponse: null,
    };
  case loginActionTypes.refresh_token.REQUEST:
    return {
      ...state,
      authenticatingToken: true,
    };
    // case loginActionTypes.refresh_token.SUCCESS:
    // return {
    //   ...state,
    //   authenticatingToken: true,
    // };
    // case loginActionTypes.refresh_token.FAILURE:
    // return {
    //   ...state,
    //   authenticatingToken: false,
    // };
  case loginActionTypes.logout_user.SUCCESS:
    return {
      ...state,
      authenticating: false,
      authenticatingToken: false,
      errorMessage: null,
      access_token: null,
      loginUserInfo: null,
    };
  case loginActionTypes.post_forgotPassword.REQUEST:
  case loginActionTypes.post_resetPassword.REQUEST:
    return {
      ...state,
      authenticating: true,
    };
  case loginActionTypes.post_forgotPassword.FAILURE:
  case loginActionTypes.post_resetPassword.FAILURE:
    return {
      ...state,
      authenticating: false,
      errorMessage: payload.errorMessage,
    };
  case loginActionTypes.post_forgotPassword.SUCCESS:
  case loginActionTypes.post_resetPassword.SUCCESS:
    return {
      ...state,
      authenticating: false,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/logins/reducers/LoginReducer.js